/// <summary>
/// Author  : Rohan Gaikwad
/// Date    : 05/09/2018
/// Scope   : Check elements position & proximity in viewport
/// Version : 0.0.1
/// </summary>
/*
Changelog
*/

(function ($) {
    $.fn.proximity = function (callback, offsetdistance, timeOut) {

        var offsetY = typeof offsetdistance == "undefined" ? 350 : offsetdistance;
        var cTimeout = typeof timeOut == "undefined" ? 45 : timeOut;

        function checkProximity(elem, callback, success) {
            var _rect = elem.getBoundingClientRect();
            var screenH = window.innerHeight || document.documentElement.clientHeight;
            var range = screenH + offsetY;

            if (_rect.top <= range) {
                callback();
                success();
                if (debugMode) console.log("screenH: " + screenH + ", offsetY:" + offsetY + ", range:" + range + ", y: " + _rect.top);
            }
        }

        return this.each(function () {
            var count = 1, _elem = this;
            if (typeof callback == "function") {
                // perform default check
                checkProximity(_elem, callback, function () { count-- });
                var manualIntervalID = 0;

                // manually execute the callback function after a set period of time.
                var manualTimeoutID = setTimeout(function () {
                    if (count > 0) {
                        console.log("Manually triggered");
                        clearInterval(manualIntervalID);
                        callback();
                        count--;
                    }
                }, cTimeout * 1000);

                // perform check on scroll
                $(window).scroll(function (e) {
                    if (count > 0) {
                        checkProximity(_elem, callback, function () {
                            count--;
                            clearTimeout(manualTimeoutID);
                        });
                    }
                });

                manualIntervalID = setInterval(function () {
                    if (count > 0) {
                        checkProximity(_elem, callback, function () {
                            count--;
                            clearInterval(manualIntervalID);
                            clearTimeout(manualTimeoutID);
                        });
                    }
                }, 500);


            }
        });

    };
}(jQuery));